export function createNumericalCompare<T>(getNumber: (a: T) => number): (a: T, b: T) => -1 | 0 | 1 {
    return (a, b) => getNumber(a) > getNumber(b) ? 1 : getNumber(a) === getNumber(b) ? 0 : -1;
}